import React, { useContext } from 'react'
import { type TabStateReturn } from 'reakit'

export const TabsContext = React.createContext<TabStateReturn & { defaultTabId?: string }>(
  // @ts-ignore, can't provide a valid default context
  null
)
export const useTabsContext = () => useContext(TabsContext)
